var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btns"},[_c('div',{staticClass:"kf",on:{"click":_vm.callCustomerService}},[_c('img',{staticClass:"kf-icon",attrs:{"src":"https://cdn.133.cn/ticket/images/hangban/vue/hltrip/icon/kf@2x.png"}}),_c('div',{staticClass:"kf-txt"},[_vm._v("咨询")])]),_c('div',{staticClass:"buy-btn",on:{"click":_vm.book}},[_vm._v("预订")])])
}
var staticRenderFns = []

export { render, staticRenderFns }